import { useMemo } from 'react';
import { getPasswordRules } from '../../utils/util';

export default function PasswordRules({ password, confirmPassword = null }: { password: string, confirmPassword?: string | null }) {

    const passwordRules = useMemo(() => getPasswordRules(password, confirmPassword), [password, confirmPassword]);

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "8px", padding: "4px", borderRadius: "10px", }}                                        >
            {passwordRules.map((rule, index) => (
                <div
                    key={index}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        fontSize: "12px",
                        color: rule.valid ? "#16A34A" : "#94A3B8",
                        transition: "0.2s ease",
                    }}
                >
                    <span
                        style={{
                            width: "18px",
                            height: "18px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "11px",
                            background: rule.valid ? "#DCFCE7" : "#E2E8F0",
                            color: rule.valid ? "#16A34A" : "#64748B",
                            fontWeight: 700,
                        }}
                    >
                        {rule.valid ? "✓" : "•"}
                    </span>

                    <span>{rule.label}</span>
                </div>
            ))}
        </div>
    )
}
